import { render, staticRenderFns } from "./EditRecruiter.vue?vue&type=template&id=34c7f020"
import script from "./EditRecruiter.vue?vue&type=script&lang=js"
export * from "./EditRecruiter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports